<script setup lang="ts">
import { useToast } from './useToast';

const { toasts } = useToast();
</script>

<template>
  <TransitionGroup
    tag="div"
    class="tw:fixed tw:top-4 tw:right-4 tw:z-50 tw:flex tw:flex-col tw:gap-2 tw:pointer-events-none"
  >
    <div
      v-for="toast in toasts"
      :key="toast.id"
      class="tw:bg-white tw:rounded-xl tw:shadow-m tw:px-6 tw:py-4 tw:typography-body-1 tw:text-primary tw:pointer-events-auto tw:border-l-4"
      :class="toast.variant === 'success' ? 'tw:border-vuln-low' : 'tw:border-vuln-high'"
    >
      {{ toast.message }}
    </div>
  </TransitionGroup>
</template>

<style scoped>
.v-enter-active,
.v-leave-active {
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
}

.v-enter,
.v-leave-to {
  opacity: 0;
  transform: translateX(0.75rem);
}
</style>
